export default __webpack_public_path__ + "static/media/Messages.5bfe59e7.svg";